import React from 'react';
import { UITicketComment } from '@api/v1';
import { Message } from './Message';

export const TicketCommentMessage = ({ item }: { item: UITicketComment }) => {
	return <Message item={item} />;
};
